import React from 'react'
import { useIsSidebarCollapsed } from '../../store/useSidebarStore'
import { Sidebar, SidebarProps } from '../Sidebar'
import styles from './SidebarLayout.module.css'

const cx = (...classes: Array<string | false | undefined>) => classes.filter(Boolean).join(' ')

export const SidebarLayout = ({
    children,
    sidebarProps
}: {
    children: React.ReactNode
    sidebarProps: SidebarProps
}) => {
    const isCollapsed = useIsSidebarCollapsed()

    return (
        <div className={cx(styles.root, isCollapsed && styles.collapsed)}>
            <div className={styles.spacer}>
                <Sidebar {...sidebarProps} />
            </div>

            <div className={styles.content}>
                <div className={styles.inner}>{children}</div>
            </div>
        </div>
    )
}
